import { gql } from '@apollo/client';

export default gql`
  query GetEventBySlug($slug: String! = "") {
    events(filters: { slug: { eq: $slug } }) {
      title
      slug
      eventStartDate
      eventEndDate
      disableBookmarkEmails
      hideAllPollResults
      authType
      marketoBaseUrl
      marketoMunchkinId
      marketoFormId
      keywords(pagination: { limit: -1 }) {
        keyword
      }
      schedule {
        slug
        scheduleItem(pagination: { limit: -1 }) {
          id
          title
          startTime
          endTime
          slug
          description_ck
          image {
            url
          }
          presenters {
            name
            title
            company
            linkedinUrl
            twitterUrl
            email
          }
        }
        keywords(pagination: { limit: -1 }) {
          keyword
        }
      }
      navigation {
        navItems(pagination: { limit: -1 }) {
          title
          url
          target
        }
      }
      socials {
        facebookUrl
        instagramUrl
        twitterUrl
        nokiaUrl
      }
      signUpIntro {
        title
        description
        keywords(pagination: { limit: -1 }) {
          keyword
        }
      }
      landingPageContent {
        backgroundImage {
          url
        }
        btnText
        calendarBtnText
        keywords(pagination: { limit: -1 }) {
          keyword
        }
      }
      homePage {
        __typename
        ... on ComponentExperienceExperienceGroup {
          id
          experience {
            keywords(pagination: { limit: -1 }) {
              keyword
            }
            experience_items(
              pagination: { limit: -1 }
              filters: { publishedAt: { not: null } }
            ) {
              documentId
              slug
              title
              description
              hidden
              hideExitButton
              defaultExperience
              disableBookmarking
              experienceUrl
              isExternalLink
              keywords(pagination: { limit: -1 }) {
                keyword
              }
              document {
                url
                ext
              }
              isDocumentDownload
              btnText
              carouselBtnText
              preExperienceBackground {
                url
              }
              order
              interactions {
                userInteraction {
                  interactions {
                    __typename
                    ... on ComponentIntersPollInteraction {
                      poll {
                        documentId
                        hideOnResultsPage
                      }
                    }
                    ... on ComponentIntersRatingInteraction {
                      rating {
                        documentId
                        hideOnResultsPage
                      }
                    }
                  }
                }
              }
            }
          }
        }
        ... on ComponentNewsNewsGroup {
          id
          news_groups(
            pagination: { limit: -1 }
            filters: { publishedAt: { not: null } }
          ) {
            documentId
            slug
            homeCarouselTitle
            keywords(pagination: { limit: -1 }) {
              keyword
            }
            news_items(pagination: { limit: -1 }) {
              slug
              title
              date
              author
              buttonText
              image {
                url
              }
            }
          }
        }
        ... on ComponentFilterFiltersGroup {
          id
          filter_groups(
            pagination: { limit: -1 }
            filters: { publishedAt: { not: null } }
          ) {
            documentId
            homeCarouselTitle
            keywords(pagination: { limit: -1 }) {
              keyword
            }
            filterItems(pagination: { limit: -1 }) {
              slug
              title
              iframeLink
              backgroundImage {
                url
              }
              circleImage {
                url
              }
              keywords(pagination: { limit: -1 }) {
                keyword
              }
            }
          }
        }
        ... on ComponentIntersIntersGrpHome {
          id
          user_interactions(
            pagination: { limit: -1 }
            filters: { publishedAt: { not: null } }
          ) {
            interactions {
              __typename
              ... on ComponentIntersPollInteraction {
                poll {
                  documentId
                  hideOnResultsPage
                }
              }
              ... on ComponentIntersRatingInteraction {
                rating {
                  documentId
                  hideOnResultsPage
                }
              }
            }
          }
        }
        ... on ComponentFlexpsFlExpGr {
          id
          flat_experience_groups(pagination: { limit: -1 }) {
            documentId
            title
            slug
            homeCarouselTitle
            keywords(pagination: { limit: -1 }) {
              keyword
            }
            flat_experiences(pagination: { limit: -1 }) {
              slug
              buttonText
              title
              disableBookmarking
              image {
                url
              }
            }
          }
        }
      }
    }
  }
`;
